import { useState } from 'react';
import { IconUp, IconDown } from '@ui/src';
import { DeviceTypes } from './types';
import months from '../../hoc/variables';

import cn from './profile.module.css';

const Device = ({
  device,
  endSession,
  endSessionInProgress,
  endSessionId,
  sessionsIsAvailable,
  onViewSessionClick,
}: DeviceTypes) => {
  const [collapsed, setCollapsed] = useState(true);

  let date = '';

  if (device?.createdAt || device?.updatedAt) {
    const createdAt =
      new Date(device?.updatedAt)?.getTime() >
      new Date(device?.createdAt)?.getTime()
        ? new Date(device?.updatedAt)
        : new Date(device?.createdAt);

    const month = months[new Date(createdAt).getMonth()];
    const time = `${createdAt
      .getHours()
      .toString()
      .padStart(2, '0')}:${createdAt.getMinutes().toString().padStart(2, '0')}
     `;

    if (new Date().toLocaleDateString() === createdAt.toLocaleDateString()) {
      date = `Today at ${time}`;
    } else if (
      new Date().toLocaleDateString() ===
      new Date(new Date().setDate(createdAt.getDate() - 1)).toLocaleDateString()
    ) {
      date = `Yesterday at ${time}`;
    } else {
      date = `${month} ${createdAt.getDate()} at ${time}`;
    }
  }

  return (
    <div className={cn.device}>
      <button
        type="button"
        className={cn.showDeviceInfo}
        onClick={() => setCollapsed(!collapsed)}
      >
        {`${device.platform || 'Unknown OS'} - ${
          device.browser || 'Unknown browser'
        }`}
        {device?.isCurrent && (
          <div className={cn.currentSession}>(Current sesstion)</div>
        )}
        <div className={cn.deviceItemButtonDate}>{date}</div>
        {collapsed ? (
          <IconDown className={cn.arrowIcon} />
        ) : (
          <IconUp className={cn.arrowIcon} />
        )}
      </button>
      {!collapsed && (
        <div className={cn.deviceInfo}>
          <div className={cn.deviceInfoRow}>
            <div className={cn.deviceInfoTitle}>OS</div>
            <div className={cn.deviceInfoValue}>
              {device.platform || 'Unknown OS'}
            </div>
          </div>
          <div className={cn.deviceInfoRow}>
            <div className={cn.deviceInfoTitle}>Browser:</div>
            <div className={cn.deviceInfoValue}>
              {device.browser || 'Unknown browser'}
            </div>
          </div>
          <div className={cn.deviceInfoRow}>
            <div className={cn.deviceInfoTitle}>Creation date:</div>
            <div className={cn.deviceInfoValue}>{date}</div>
          </div>
          <div className={cn.deviceInfoRow}>
            <div className={cn.deviceInfoTitle}>IP address:</div>
            <div className={cn.deviceInfoValue}>
              {device?.ip || 'Unknown IP address'}
            </div>
          </div>
          <div className={cn.deviceControls}>
            {sessionsIsAvailable && (
              <button
                type="button"
                className={`${cn.endSession} ${cn.viewSessions}`}
                onClick={() => onViewSessionClick(device)}
              >
                View sessions
              </button>
            )}
            <button
              type="button"
              className={cn.endSession}
              onClick={() => endSession(device.id)}
            >
              {endSessionInProgress && endSessionId === device.id
                ? 'Loading...'
                : 'End session'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Device;
